export default __webpack_public_path__ + "static/media/image.dab84a11.jpg";